import React from 'react';
import { Link } from 'react-router-dom';
import ScrollReveal from './ScrollReveal';
import './HomePage.css';
import LogoMarquee from './LogoMarquee';
import SecurityArchitecture from './SecurityArchitecture';
import PageNavbar from './PageNavbar';
import CaseStudiesSection from './CaseStudiesSection';
import WorkflowDashboard from './WorkflowDashboard';
import AIWorkflowsSection from './AIWorkflowsSection';
import SocOptimizationSection from './SocOptimizationSection';
import TestimonialsSection from './TestimonialsSection';
import CTASection from './CTASection';
import ResourcesSection from './ResourcesSection';
import Footer from './Footer';
import { useHeroMonitorScroll } from '../hooks/useHeroMonitorScroll';

const HomePage = () => {
  const { heroSectionRef, monitorRef, offsetY, peekHeight } = useHeroMonitorScroll();

  const monitorStyle = {
    transform: offsetY !== null
      ? `translateY(${offsetY}px)`
      : `translateY(calc(100% - ${peekHeight}px))`,
  };

  return (
    <div className="homepage">
      <PageNavbar />

      {/* Hero + scroll-reveal monitor */}
      <section className="hero-section" ref={heroSectionRef}>
        <div className="hero-sticky">
          <div className="hero-background"></div>
          <div className="hero-stars"></div>
          <div className="hero-light-streak"></div>

          <main className="hero">
            <ScrollReveal className="hero-content" animateOnMount variant="fadeUp" duration={1.1}>
              <div className="hero-badge">
                <span className="badge-rank">24/7</span> <span className="badge-highlight">Enterprise Security & Compliance</span> Partner Across India & the UK
              </div>
              <h1 className="hero-title">
                Secure your digital world<br />
                against <span className="title-accent">modern threats.</span>
              </h1>

              <p className="hero-description">
                Proven is a cybersecurity firm partnering with enterprise leaders
                to transform complex IT challenges into robust security strategies.
              </p>

              <div className="hero-buttons">
                <Link to="/services" className="explore-btn">
                  Explore Service
                  <span className="btn-arrow">→</span>
                </Link>
                <Link to="/contact" className="get-in-touch-btn">
                  Get In Touch
                  <span className="btn-arrow">→</span>
                </Link>
              </div>
            </ScrollReveal>
          </main>

          <div className="hero-monitor-dock" ref={monitorRef} style={monitorStyle}>
            <WorkflowDashboard />
          </div>
        </div>
      </section>

      {/* Logo Marquee replacing Mission & Vision */}
      <LogoMarquee />

      {/* Security Architecture Section */}
      <SecurityArchitecture />

      {/* Case Studies Section (Trusted by Industry Leaders) */}
      <CaseStudiesSection />

      {/* AI Workflows Section (Agentic Workflows) */}
      <AIWorkflowsSection />

      {/* SOC Optimization Section (New) */}
      <SocOptimizationSection />

      <TestimonialsSection />
      <CTASection />
      <ResourcesSection />
      <Footer />
    </div>
  );
};

export default HomePage;